import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Lightbulb, HandshakeIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    title: 'People First',
    description: 'Behind every claim is a person and a family. We never lose sight of that.',
    icon: Heart
  }, {
    title: 'Continuously Evolving',
    description: 'We invest in technology and training to stay ahead of an ever-changing industry.',
    icon: Lightbulb
  }, {
    title: 'Partnership Mindset',
    description: 'We win when our clients win. Long-term relationships are at the core of our business.',
    icon: HandshakeIcon
  }];
  return <section className="py-24 bg-white overflow-hidden" data-id="element-134" data-mp="gss1kfau2ro4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135" data-mp="gr74oj11qwn3">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-136" data-mp="14hkz2g73t7ku">
          <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-137" data-mp="19ae5d8i80nz1">
            Our Values
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6" data-id="element-138" data-mp="2rm7gywxq7hdh">
            The Arissa Approach
          </h3>
          <p className="text-lg text-gray-600" data-id="element-139" data-mp="2mki6pjibv7qg">
            A proven methodology to transform your workers' compensation
            program.
          </p>
        </div>

        <div className="relative" data-id="element-140" data-mp="2wjzafve0rbjs">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-100 -translate-y-1/2 z-0" data-id="element-141" data-mp="3ab4c130y6dwr"></div>

          <div className="grid md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-142" data-mp="36a0wyiqq4lwl">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.2
            }} className="relative text-center" data-id="element-143" data-mp="3fca7h8lzsf9z" data-mpi={index}>
                  <div className="w-24 h-24 mx-auto bg-brand-navy rounded-full flex items-center justify-center mb-8 shadow-xl border-4 border-white relative group" data-id="element-144" data-mp="2tucci6ld1ll">
                    <div className="absolute inset-0 bg-brand-gold rounded-full scale-0 group-hover:scale-100 transition-transform duration-300 ease-out" data-id="element-145" data-mp="7soy9szuv69x"></div>
                    <Icon className="w-10 h-10 text-white relative z-10" data-id="element-146" data-mp="hii7inciz9b0" />

                    {/* Step Number Badge */}
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-brand-gold text-brand-navy font-bold rounded-full flex items-center justify-center border-2 border-white shadow-sm" data-id="element-147" data-mp="lju091qp4anf">
                      {index + 1}
                    </div>
                  </div>

                  <h4 className="text-2xl font-serif font-bold text-brand-navy mb-4" data-id="element-148" data-mp="15mq5ntnk0sym">
                    {step.title}
                  </h4>
                  <p className="text-gray-600 leading-relaxed max-w-sm mx-auto" data-id="element-149" data-mp="10m262jl9f3ss">
                    {step.description}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}